import { ActionTypes, ConversationActions } from "./../actions/index";
import { ConversationState } from "../states";
import { ConversationStateEnum, KEY_CONVERSATION_REQUEST } from "../../models";
import { IMessage } from "@auvious/integrations";
import { StorageService } from "../../services";

const getInitialState = (): ConversationState => {
  return {
    state: ConversationStateEnum.idle,
    type: null,
    agent: null,
    customer: null,
    customerRequest: null,
    messages: [],
    data: null,
    members: {},
    isAgentTyping: false,
    isChatMinimized: false,
  };
};

const conversation = (
  state = getInitialState(),
  action: ActionTypes
): ConversationState => {
  switch (action.type) {
    case ConversationActions.CONVERSATION_DATA_CHANGE:
      return { ...state, data: action.payload };
    case ConversationActions.CONVERSATION_STATE_CHANGE:
      return { ...state, state: action.payload };
    case ConversationActions.CONVERSATION_REQUEST_CHANGE:
      try {
        StorageService.setItem(
          KEY_CONVERSATION_REQUEST,
          JSON.stringify(action.payload),
          "session"
        );
      } catch (ex) {}
      return { ...state, customerRequest: action.payload };
    case ConversationActions.CONVERSATION_ENDED:
      return getInitialState();
    case ConversationActions.AGENT_CHANGE:
      return { ...state, agent: action.payload };
    case ConversationActions.CUSTOMER_CHANGE:
      return { ...state, customer: action.payload };
    case ConversationActions.CONVERSATION_TYPE_CHANGE:
      return { ...state, type: action.payload };
    case ConversationActions.MESSAGE_SENT:
      return { ...state, messages: [...state.messages, action.payload] };
    case ConversationActions.MESSAGE_RECEIVED:
      let message = action.payload;
      let messages, exists;
      let filter;
      const localSenderFilter = (m: IMessage) =>
        m.status === "sent" && m.isLocal && m.senderId === message.senderId;
      switch (message.type) {
        case "file":
          filter = (m: IMessage) => m.file.name === message.file.name;
          break;
        case "notice":
          filter = () => undefined;
        case "text":
        case "bot":
          filter = (m: IMessage) => m.text?.trim() == message.text;
          break;
      }
      exists = state.messages.filter(localSenderFilter).filter(filter);

      if (exists?.length > 0) {
        // get the oldest on the existing list and mark that as 'ack'
        exists.sort((a, b) => a.timestamp.valueOf() - b.timestamp.valueOf());
        const oldest = exists[0];
        messages = state.messages.map((m) =>
          // replace the oldest one and pass the metadata
          oldest.id === m.id
            ? { ...message, metadata: { ...message.metadata, ...m.metadata } }
            : m
        );
      } else {
        messages = [...state.messages, message];
      }
      return { ...state, messages };

    case ConversationActions.MESSAGE_ERROR:
      return {
        ...state,
        messages: state.messages.map((m) =>
          m.id === action.payload.id ? action.payload : m
        ),
      };
    case ConversationActions.MESSAGE_METADATA_CHANGE:
      return {
        ...state,
        messages: state.messages.map((m) =>
          m.id === action.payload.id
            ? { ...m, metadata: action.payload.metadata }
            : m
        ),
      };

    case ConversationActions.MEMBER_SET:
      return {
        ...state,
        members: {
          ...state.members,
          [action.payload.id]: action.payload,
        },
      };
    case ConversationActions.MEMBER_REMOVE:
      const { [action.payload.id]: _, ...members } = state.members;
      return {
        ...state,
        members,
      };
    case ConversationActions.AGENT_TYPING_CHANGE:
      return { ...state, isAgentTyping: action.payload };
    case ConversationActions.CONVERSATION_MINIMIZE_CHANGE:
      return { ...state, isChatMinimized: action.payload };
  }
  return state;
};

export default conversation;
